export default "__VITE_PUBLIC_ASSET__b1cd4bbd__"